

export const language = [
    {
        minimumConsumptionTip: "The Minimum Consumption is",
        welcome: "Welcome to",
        table: "Table",
        order: "Order",
        checkIn: "Check In",
        noOfPax: "Please enter number of Guest",
        enter: "ENTER",
        continueAsGuest: "Continue as guest",
        continueCheckin: "Continue",
        processingOrder: "Processing your order",
        processingPayment: "Checking your payment",
        processingPaymentDescription: "Please wait while we confirm your payment status.",
        processingOrderDescription: "Please wait while we complete this step.",
        dineInOrder: "Dine-in Order",
        startYourOrder: "Start your order",
        mobileOrderType: {
            eMenu: "E Menu",
            inRoomDining: "In Room Dining",
            delivery: "Delivery",
            dineIn: "Dine-in",
            pickup: "Pick-up",
        },
        fullName: "Full name",
        memberPassword: "Password",
        memberLoginSignup: "Member Login / Sign-up",
        paxWarning: "Please input no of Guest.",
        orderWarning: "Please select type of orders",
        checkout: "Submit Order",
        addToCart: "Add To Cart",
        add: "Add",
        qty: "Qty",
        remark: "Remark",
        bgTxt: "Please select a category to begin ordering.",
        setMeal: "Set Meal",
        required: "is required",
        pleasePick: "please pick one option",
        pleaseSelectItem: "Please Select an Item",
        subtotal: "Subtotal",
        tax: "Tax",
        serviceCharge: "Service Charge",
        submit: "Checkout",
        serviceChargeReminder: "All prices are subject to prevailing GST",
        total: "Total",
        cart: "Cart",
        reviewOrder: "View Order",
        reviewTAOrder: "Click Here for Your Order Number",
        cartTitle: "CURRENT ORDER",
        reviewTitle: "REVIEW ORDER HISTORY",
        selection: "Selection",
        paymentFail: "Payment Failed",
        paymentFailDesc: "Your transaction has failed.",
        tryAgain: "Please try again.",
        returnCK: "Return to Checkout",
        success: "Success",
        yourOrderNo: "Your Order No",
        orderConfirm: "We have received your purchase request",
        orderPrepare: "We have received Order and are currently preparing your order.",
        contactShortly: "We will be in touch shortly!",
        returnMain: "Return to Menu",
        cancel: "Cancel",
        cancelDesc: "Click below to return to Checkout",
        name: "Name",
        phone: "Phone",
        ok: "Ok",
        confirmCK: "Submit Order?",
        lockRound: "Lock in this round?",
        roundSendOne: "{count} item in this round will be sent. This round can't be edited after sending.",
        roundSendMany: "{count} items in this round will be sent. This round can't be edited after sending.",
        keepEditing: "Keep editing",
        sendToKitchen: "Send to Kitchen",
        creditCard: "Credit Card",
        payOnline: "Pay Online",
        roomCharge: "Room Charge",
        payAtCounterLabel: "Pay At Counter",
        payLater: "Pay Later",
        storeCreditLabel: "Advocado Store Credit",
        payNowLabel: "PayNow",
        acknowledgePaymentTerms: "I acknowledge the",
        paymentTermsLabel: "Payment Terms and Conditions",
        paymentTermsWarning: "Please acknowledge the payment terms and conditions.",
        deliveryConsent: "I consent to the use of my personal data to process and fulfil my order",
        viewDetails: "View detail",
        deliveryTermsLabel: "Delivery Terms and Conditions",
        deliveryConsentWarning: "Please consent to the use of your personal data to process and fulfil your order.",
        bookingTime: "Pick Up time",
        deliveryTime: "Delivery Time",
        today: "Today",
        tomorrow: "Tomorrow",
        selectDateWarning: "Please fill in phone and time",
        selectDateWarning1: "Please fill in phone, time and address",
        selectRoomWarning: "Room No, Name and Phone No is require",
        pleaseSelect: "Please choose the way to pick up the meal",
        howWouldYouLikeToOrder: "How would you like to order",
        pleasePayment: "Please select the payment method",
        pleaseSelectOne: "Please select",
        delivery: "Delivery",
        takeIt: "Take it yourself",
        deliveryFee: "Delivery Fee",
        address: "Address",
        remark: "Remark",
        totalAmount: "Total Amount",
        additional: "Additional",
        belowMinSpending: "Below Min. Spending Amount",
        belowMinSpending2: "The minimum spending threshold has not been reached.",
        belowMinSpending3: "Minimum amount:",
        edit: "EDIT",
        frequentBought: "You may like it",
        back: "Back",
        or: "Or",
        loginAsGuest: "Login As Guest",
        MemberLogin: "Member Login / Sign Up",
        memberSignIn: "Member Login",
        // login: "Login / Register",
        login: "Login",
        agree: "Agree",
        reject: "Reject",
        forgetPwd: "Forgot Password",
        logout: "Logout",
        memberInfo: "Member Info",
        cashback: "Cashback",
        loyalty: "Loyalty Points",
        rewardDisclaimer: "Kindly place your food first and redeem your voucher/pts upon payment",
        rewardRedeemDisclaimer: "Please redeem your points/ vouchers at the checkout page",
        continue: "Continue",
        generalSubmit: "Submit",
        member: "Member",
        close: "Close",
        register: "Sign Up",
        male: "Male",
        female: "Female",
        agreePdpa: "Agree Terms & Condition",
        email: "Email",
        gender: "Gender",
        topUpAmount: "Top Up Amount",
        discount: "Discount",
        guest: "No of Guest",
        reserveTime: "Reserved Date",
        confirmPayment: "Confirm Payment",
        redeemVoucher: "Redeem Voucher / Loyalty Points",
        somethingWentWrong: "Something went wrong",
        orderFail: "POS failed to Receive",
        orderFailDesc: "Server received your order, however POS didnt response. Please contact waiter (Please don't order again)",
        dob: "DOB",
        promoCode: "Voucher No",
        apply: "Apply",
        pendingOrder: "Pending Order",
        submitAndPay: "Submit and Pay",
        optional: "Optional",
        postal: "Postal",
        unitNo: "Unit No",
        roomNo: "Room No",
        takeAway: "Takeaway",
        reviewOrderStatus: "Check Order Status",
        currentOrderStatus: "Current Kitchen Status",
        preparing: "Preparing",
        readyToCollect: "Ready to Collect",
        pickUpPoint: "Pick Up Point",
        insufficientCredit: "Insufficient Credit",
        redeem: "Redeem",
        recentBought: "Your Last Order",
        addAll: "Add All to basket",
        roomService: "Room Service",
        orderSummary: "Order Summary",
        orderSubmit: "Order Submitted",
        dineIn:"Dine In"
    },
    {
        minimumConsumptionTip: "需满足最低消费",
        welcome: "欢迎来到",
        table: "桌子",
        order: "下单",
        checkIn: "登入时间",
        noOfPax: "请输入人数",
        enter: "进入",
        continueAsGuest: "\u4ee5\u8bbf\u5ba2\u8eab\u4efd\u7ee7\u7eed",
        continueCheckin: "\u7ee7\u7eed",
        processingOrder: "\u6b63\u5728\u5904\u7406\u60a8\u7684\u8ba2\u5355",
        processingPayment: "正在查询您的付款",
        processingPaymentDescription: "请稍候，我们正在确认您的付款状态。",
        processingOrderDescription: "\u8bf7\u7a0d\u5019\uff0c\u6211\u4eec\u6b63\u5728\u5b8c\u6210\u6b64\u6b65\u9aa4\u3002",
        dineInOrder: "\u5802\u98df\u70b9\u9910",
        startYourOrder: "\u5f00\u59cb\u70b9\u9910",
        mobileOrderType: {
            eMenu: "电子菜单",
            inRoomDining: "客房用餐",
            delivery: "外送",
            dineIn: "堂食",
            pickup: "自取",
        },
        fullName: "\u59d3\u540d",
        memberPassword: "\u5bc6\u7801",
        memberLoginSignup: "\u4f1a\u5458\u767b\u5f55 / \u6ce8\u518c",
        paxWarning: "请输入人数",
        orderWarning: "请选择菜单",
        checkout: "下单",
        addToCart: "添加到菜单",
        add: "添加",
        qty: "数量",
        remark: "备注",
        bgTxt: "请选择类别",
        setMeal: "套餐",
        required: "必选",
        pleasePick: "请选择",
        pleaseSelectItem: "请选择物品",
        subtotal: "小计",
        tax: "税收",
        serviceCharge: "服务费",
        submit: "下单",
        serviceChargeReminder: "所有价格均加收消费税",
        total: "总额",
        cart: "Cart",
        reviewOrder: "已下订单",
        reviewTAOrder: "点击查看订单序号",
        cartTitle: "CURRENT ORDER",
        reviewTitle: "查看已下订单",
        selection: "选择",
        paymentFail: "付款失败",
        paymentFailDesc: "交易失败.",
        tryAgain: "请再尝试.",
        returnCK: "回到下单页面",
        success: "下单成功",
        yourOrderNo: "您的单号",
        orderConfirm: "我们已收到您的订单",
        orderPrepare: "我们已收到你的订单，正在准备当中",
        contactShortly: "食物即将准备",
        returnMain: "回到菜单",
        cancel: "取消",
        cancelDesc: "点击以下按钮回到订单页面",
        name: "姓名",
        phone: "联络号码",
        ok: "Ok",
        confirmCK: "确定提交?",
        lockRound: "确认本轮订单？",
        roundSendOne: "本轮 {count} 件商品将发送至厨房。发送后无法修改本轮订单。",
        keepEditing: "继续编辑",
        sendToKitchen: "发送至厨房",
        creditCard: "信用卡",
        payOnline: "在线付款",
        roomCharge: "记入房账",
        payAtCounterLabel: "柜台付款",
        payLater: "稍后付款",
        storeCreditLabel: "Advocado 储值金",
        payNowLabel: "PayNow",
        acknowledgePaymentTerms: "我已阅读并同意",
        paymentTermsLabel: "付款条款与条件",
        paymentTermsWarning: "请确认同意付款条款与条件。",
        deliveryConsent: "我同意使用我的个人资料来处理和完成我的订单",
        viewDetails: "查看详情",
        deliveryTermsLabel: "配送条款与条件",
        deliveryConsentWarning: "请同意使用您的个人资料来处理和完成您的订单。",
        roundSendMany: "本轮 {count} 件商品将发送至厨房。发送后无法修改本轮订单。",
        bookingTime: "接送时间",
        deliveryTime: "接送时间",
        today: "今天",
        tomorrow: "明天",
        selectDateWarning: "请填写电话和时间",
        selectDateWarning1: "请填写电话、时间和地址",
        selectRoomWarning: "需要填上房号, 名字 和 电话号码",
        pleaseSelect: "请选择取餐方式",
        howWouldYouLikeToOrder: "您想如何点餐",
        pleasePayment: "请选择支付方式",
        pleaseSelectOne: "请选择",
        delivery: "配送",
        takeIt: "自取",
        deliveryFee: "配送费",
        address: "地址",
        remark: "备注",
        totalAmount: "总金额",
        additional: "额外金额",
        belowMinSpending: "低于最低消费",
        belowMinSpending2: "需要超过一定金额才能线上支付",
        belowMinSpending3: "最低金额:",
        edit: "更改",
        frequentBought: "猜你喜欢",
        back: "返回",
        or: "或者",
        loginAsGuest: "以访客身份登录",
        MemberLogin: "会员登陆 / 注册",
        memberSignIn: "会员登陆",
        // login: "登入 / 注册",
        login: "登入",
        agree: "同意",
        reject: "反对",
        forgetPwd: "忘记密码",
        logout: "退出",
        memberInfo: "会员资料",
        cashback: "返现",
        loyalty: "积分",
        rewardDisclaimer: "请先下单，然后在付款时才兑现优惠卷/积分",
        rewardRedeemDisclaimer: "请在付款前兑现优惠卷/积分",
        continue: "继续",
        generalSubmit: "提交",
        member: "会员",
        close: "关闭",
        register: "注册会员",
        male: "男",
        female: "女",
        agreePdpa: "同意条款和条件",
        email: "邮件",
        gender: "性别",
        topUpAmount: "充值金额",
        discount: "折扣",
        guest: "人数",
        reserveTime: "预定日期",
        confirmPayment: "确认付款",
        redeemVoucher: "兑现优惠卷/分数",
        somethingWentWrong: "Something went wrong",
        orderFail: "POS无法接收",
        orderFailDesc: "服务器已收到订单，但无法传到收银机, 请联系服务员（不必再下单)",
        dob: "生日日期",
        promoCode: "优惠卷",
        apply: "使用",
        pendingOrder: "待处理订单",
        submitAndPay: "下单付款",
        optional: "非必填",
        postal: "邮编",
        unitNo: "单位",
        roomNo: "房号",
        takeAway: "外带",
        reviewOrderStatus: "检查订单",
        currentOrderStatus: "目前厨房状态",
        preparing: "准备当中",
        readyToCollect: "准备领取",
        pickUpPoint: "取餐点",
        insufficientCredit: "余额不足",
        redeem: "兑换",
        recentBought: "上一次下单",
        addAll: "加入购物车",
        roomService: "房间服务",
        orderSummary: "订单摘要",
        orderSubmit: "订单已提交",
        dineIn:"堂食"
    }
]
